import { Routes, Route as RouteItem, useNavigate } from "react-router-dom";
import Layout from "../components/layout/Layout";
// import LogIn from "../features/login/Login";
import Country from "../features/country/Country";
import User from "../features/user/User";
import CreateUser from "../features/user/CreateUser";
import State from "../features/state/State";
import City from "../features/city/City";
import Region from "../features/region/Region";
import SpecialityType from "../features/specialitytype/SpecialityType";
import HotelBlock from "../features/hotelblock/HotelBlock";
import CreateHotelBlock from "../features/hotelblock/CreateHotelBlock";
import Sector from "../features/sector/Sector";
import RoomType from "../features/roomtype/RoomType";
import VendorType from "../features/vendortype/VendorType";
import MealType from "../features/mealtype/MealType";
import Vendor from "../features/vendor/Vendor";
import CreateVendor from "../features/vendor/CreateVendor";
import Nationality from "../features/nationality/Nationality";
import SectorCity from "../features/sectorcity/SectorCity";
import TermsAndCondition from "../features/termsandcondition/TermsAndCondition";
import Tour from "../features/tour/Tour";
import CreateTour from "../features/tour/CreateTour";
import Company from "../features/company/Company";
import CreateCompany from "../features/company/CreateCompany";
import Gst from "../features/gst/Gst";
import AirlineBlock from "../features/airlineblock/AirlineBlock";
import CreateAirlineBlock from "../features/airlineblock/CreateAirlineBlock";
import Hotel from "../features/hotel/Hotel";
import CreateHotel from "../features/hotel/CreateHotel";
import Currency from "../features/currency/Currency";
import Airline from "../features/airline/Airline";
import CreateAirline from "../features/airline/CreateAirline";
// import Airport from "../features/airport/Airport";
import AirlineClass from "../features/airlineclass/AirlineClass";
import VehicleSharingPax from "../features/vehiclesharingpax/VehicleSharingPax";
import FlightPlace from "../features/flightplace/FlightPlace";
import PaxType from "../features/paxtype/PaxType";
import Route from "../features/route/Route";
import Branch from "../features/branch/Branch";
import CreateBranch from "../features/branch/CreateBranch";
import FoodOption from "../features/foodoption/FoodOption";
import GroupRoute from "../features/grouproute/GroupRoute";
import CreateGroupRoute from "../features/grouproute/CreateGroupRoute";
import CreateTourBooking from "../features/tourbooking/CreateTourBooking";
import TourBooking from "../features/tourbooking/TourBooking";
import HotelVoucher from "../features/hotelvoucher/HotelVoucher";
import CreateHotelVoucher from "../features/hotelvoucher/CreateHotelVoucher";
import PaymentReceipt from "../features/paymentreceipt/PaymentReceipt";
import CreatePaymentReceipt from "../features/paymentreceipt/CreatePaymentReceipt";
import RouteVoucher from "../features/routevoucher/RouteVoucher";
import CreateRouteVoucher from "../features/routevoucher/CreateRouteVoucher";
import RoomCategory from "../features/roomcategory/RoomCategory";
import HotelMapping from "../features/hotelmapping/HotelMapping";
import RippleButton from "../components/common/RippleButton";
import Dashboard from "../features/dashboard/Dashboard";
import AirlineVoucher from "../features/airlinevoucher/AirlineVoucher";
import CreateAirlineVoucher from "../features/airlinevoucher/CreateAirlineVoucher";
import CompanyWiseBookingReportForm from "../features/reports/reportsform/CompanyWiseBookingReportForm";
import UserWiseBookingReportForm from "../features/reports/reportsform/UserWiseBookingReportForm";
import HotelBlockRoomStatusReportForm from "../features/reports/reportsform/HotelBlockRoomStatusReportForm";
import CustomerReportForm from "../features/reports/reportsform/CustomerReportForm";
import TourBookingReport from "../features/reports/reportsform/TourBookingReport";
import PaymentReceiptCustomerReport from "../features/reports/reportsform/PaymentReceiptCustomerReport";
import Menu from "../features/menu/Menu";
import Rights from "../features/rights/Rights";
import TourReportForm from "../features/reports/reportsform/TourReportForm";
import TourBookingInvoiceForm from "../features/reports/reportsform/TourBookingInvoiceForm";
import TourBookingInvoiceView from "../features/reports/reportsform/TourBookingInvoiceView";
import AirlineBlockView from "../features/reports/reportsform/AirlineBlockView";
import UserType from "../features/userType/UserType";
import CreateUserType from "../features/userType/CreateUserType";
import CompanyWiseBookingReportView from "../features/reports/reportsform/CompanyWiseBookingReportView";
import UserWiseBookingReportView from "../features/reports/reportsform/UserWiseBookingReportView";
import HotelBlockRoomStatusReportView from "../features/reports/reportsform/HotelBlockRoomStatusReportView";
import CustomerReportView from "../features/reports/reportsform/CustomerReportView";
import TourReportView from "../features/reports/reportsform/TourReportView";
import ManageLedgerForm from "../features/reports/reportsform/ManageLedgerForm";
import ManageLedgerView from "../features/reports/reportsform/ManageLedgerView";
import GroupRoutePrint from "../features/grouproute/GroupRoutePrint";
import { PrivateLoginRoute, PrivateRoute } from "./PrivateRoute";
import VehicleType from "../features/vehicletype/VehicleType";
import Festivals from "../features/festival/Festivals";
import CancellationPolicy from "../features/companypolicy/CancellationPolicy";
import LeadSource from "../features/leadsource/LeadSource";
import Vehicle from "../features/vehicle/Vehicle";
import CreateVehicle from "../features/vehicle/CreateVehicle";
import CreateItineary from "../features/itinerary/CreateItinerary";
import Itinerary from "../features/itinerary/Itinerary";
import CreateAgent from "../features/agent/CreateAgent";
import Agent from "../features/agent/Agent";
import ItineraryFacility from "../features/ItineraryFacility/ItineraryFacility";
import Inquiry from "../features/inquiry/Inquiry";
import CreateInquiry from "../features/inquiry/CreateInquiry";
import LeadStage from "../features/leadstage/LeadStage";
import Quotation from "../features/quotation/Quotation";
import CreateQuotation from "../features/quotation/CreateQuotation";
import Integrations from "../features/integrations/Integrations";
import FacebookIntegration from "../features/integrations/FacebookIntegration";
import LeadCenter from "../features/integrations/LeadCenter";
import LeadCenterList from "../features/integrations/LeadCenterList";
import Lead from "../features/lead/Lead";
import Contact from "../features/contact/Contact";
import EditContact from "../features/contact/EditContact";
import DashboardQuotations from "../features/dashboard/dashboardLists/DashboardQuotations";
import DashboardBookings from "../features/dashboard/dashboardLists/DashboardBookings";
import DashBoardInquiries from "../features/dashboard/dashboardLists/DashBoardInquiries";
import DashboardLeads from "../features/dashboard/dashboardLists/DashboardLeads";
import DashboardFollowups from "../features/dashboard/dashboardLists/DashboardFollowups";
import Testimonial from "../features/testimonial/Testimonial";
import SeoTag from "../features/seotag/SeoTag";
import CreateSeoTag from "../features/seotag/CreateSeoTag";
import Banner from "../features/banner/Banner";
import CreateBanner from "../features/banner/CreateBanner";
import Blog from "../features/blog/Blog";
import CreateBlog from "../features/blog/CreateBlog";
import Service from "../features/service/Service";
import CreateService from "../features/service/CreateService";
import FAQ from "../features/faq/FAQ";
import CreateFAQ from "../features/faq/CreateFAQ";
import CMS from "../features/cms/CMS";
import CreateCMS from "../features/cms/CreateCMS";
import UsefulLinks from "../features/usefullinks/UsefulLinks";
import CreateUsefulLinks from "../features/usefullinks/CreateUsefulLinks";
import Setting from "../features/setting/Setting";
import CreateSector from "../features/sector/CreateSector";
import FITBooking from "../features/fitbooking/FITBooking";
import CreateFITBooking from "../features/fitbooking/CreateFITBooking";
import Brochure from "../features/brochure/Brochure";
import CreateBrochure from "../features/brochure/CreateBrochure";
import PackageQuotationPrint from "../features/quotation/PackageQuotationPrint";
import FITBookingPrint from "../features/fitbooking/FITBookingPrint";
import AdminSetting from "../features/adminsetting/AdminSetting";
import FITBookingCancellation from "../features/fitbooking/FITBookingCancellation";
import CreateOrganization from "../features/organization/CreateOrganization";
import Template from "../features/template/Template";
import CreateTemplate from "../features/template/CreateTemplate";
import WhatsappAutoTrigger from "../features/whatsappautotrigger/WhatsappAutoTrigger";
import CreateWhatsappAutoTrigger from "../features/whatsappautotrigger/CreateWhatsappAutoTrigger";
import EmailAutoTrigger from "../features/emailautotrigger/EmailAutoTrigger";
import CreateEmailAutoTrigger from "../features/emailautotrigger/CreateEmailAutoTrigger";
import LeadAssignSetting from "../features/leadassignsetting/LeadAssignSetting";
import HotelVoucherView from "../features/hotelvoucher/HotelVoucherView";
import LeadReportForm from "../features/reports/reportsform/LeadReportForm";
import LeadReportView from "../features/reports/reportsform/LeadReportView";
import InquiryReportForm from "../features/reports/reportsform/InquiryReportForm";
import InquiryReportView from "../features/reports/reportsform/InquiryReportView";
import VisaCategory from "../features/visacategory/VisaCategory";
import QuotationReportForm from "../features/reports/reportsform/QuotationReportForm";
import QuotationReportView from "../features/reports/reportsform/QuotationReportView";
import FITBookingReportForm from "../features/reports/reportsform/FITBookingReportForm";
import FITBookingReportView from "../features/reports/reportsform/FITBookingReportView";
import DashboardFITBookings from "../features/dashboard/dashboardLists/DashboardFITBookings";
import Login from "../features/login/Login";
import CreateFlightQuotation from "../features/quotation/CreateFlightQuotation";
import CreateHotelQuotation from "../features/quotation/CreateHotelQuotation";
import CreateVisaQuotation from "../features/quotation/CreateVisaQuotation";
import Document from "../features/document/Document";
import VisaCountry from "../features/visacountry/VisaCountry";
import TravelPurpose from "../features/travelpurpose/TravelPurpose";
import VisaProcessingOption from "../features/visaprocessingoption/VisaProcessingOption";
import AdditionalService from "../features/additionalservice/AdditionalService";
import EmploymentStatus from "../features/employmentstatus/EmploymentStatus";
import SponsorshipType from "../features/sponsorshiptype/SponsorshipType";
import HotelQuotePrint from "../features/quotation/print/HotelQuotePrint";
import FlightQuotePrint from "../features/quotation/print/FlightQuotePrint";
import VisaQuotePrint from "../features/quotation/print/VisaQuotePrint";
import TourService from "../features/tourservice/TourService";
import VisaGateway from "../features/visagateway/VisaGateway";
import VisaEntryType from "../features/visaentrytype/VisaEntryType";
import ClientLogo from "../features/clientlogo/ClientLogo";
import Sightseen from "../features/sightseen/Sightseen";
import DashboardFollowupsChartWise from "../features/dashboard/dashboardLists/DashboardFollowupsChartWise";
import WebBranch from "../features/webbranch/WebBranch";
import CreateWebBranch from "../features/webbranch/CreateWebBranch";
import InstagramStory from "../features/instagramstory/InstagramStory";
import Community from "../features/community/Community";
import CreateCommunity from "../features/community/CreateCommunity";
import Activity from "../features/activity/Activity";
import Weekendgateways from "../features/weekendgatways/Weekendgateways";
import CreateWeekendgateways from "../features/weekendgatways/CreateWeekendgateways";
import Newsletter from "../features/newsletter/Newsletter";
import BookingSummaryReportForm from "../features/reports/reportsform/BookingSummaryReportForm";
import BookingSummaryReportView from "../features/reports/reportsform/BookingSummaryReportView";
import RevenueGeneratedByUserReportForm from "../features/reports/reportsform/RevenueGeneratedByUserReportForm";
import RevenueGeneratedByUserReportView from "../features/reports/reportsform/RevenueGeneratedByUserReportView";
import InquiryConversionReportForm from "../features/reports/reportsform/InquiryConversionReportForm";
import InquiryConversionReportView from "../features/reports/reportsform/InquiryConversionReportView";
import DestinationWisePerformanceReportForm from "../features/reports/reportsform/DestinationWisePerformanceReportForm";
import DestinationWisePerformanceReportView from "../features/reports/reportsform/DestinationWisePerformanceReportView";
import LeadSourceAnalysisReportForm from "../features/reports/reportsform/LeadSourceAnalysisReportForm";
import LeadSourceAnalysisReportView from "../features/reports/reportsform/LeadSourceAnalysisReportView";
import UserPerformanceReportForm from "../features/reports/reportsform/UserPerformanceReportForm";
import UserPerformanceReportView from "../features/reports/reportsform/UserPerformanceReportView";
import QuotationStatusReportForm from "../features/reports/reportsform/QuotationStatusReportForm";
import QuotationStatusReportView from "../features/reports/reportsform/QuotationStatusReportView";
import ProfitabilityReportForm from "../features/reports/reportsform/ProfitabilityReportForm";
import ProfitabilityReportView from "../features/reports/reportsform/ProfitabilityReportView";
import CouponCode from "../features/couponcode/CouponCode";
import PendingInquiryFollowupReportForm from "../features/reports/reportsform/PendingInquiryFollowupReportForm";
import PendingInquiryFollowupReportView from "../features/reports/reportsform/PendingInquiryFollowupReportView";
import LostInquiryAnalysisReportForm from "../features/reports/reportsform/LostInquiryAnalysisReportForm";
import LostInquiryAnalysisReportView from "../features/reports/reportsform/LostInquiryAnalysisReportView";
import Section from "../features/section/Section";
import Designation from "../features/designation/Designation";
import MonthlyRevenueTrendReportForm from "../features/reports/reportsform/MonthlyRevenueTrendReportForm";
import MonthlyRevenueTrendReportView from "../features/reports/reportsform/MonthlyRevenueTrendReportView";
import UpcomingDepartureDataReportForm from "../features/reports/reportsform/UpcomingDepartureDataReportForm";
import UpcomingDepartureDataReportView from "../features/reports/reportsform/UpcomingDepartureDataReportView";
import CustomerRetentionReportView from "../features/reports/reportsform/CustomerRetentionReportView";
import CustomerRetentionReportForm from "../features/reports/reportsform/CustomerRetentionReportForm";
import GSTAndTaxSummaryReportForm from "../features/reports/reportsform/GSTAndTaxSummaryReportForm";
import GSTAndTaxSummaryReportView from "../features/reports/reportsform/GSTAndTaxSummaryReportView";
import ServiceTypeRevenueReportForm from "../features/reports/reportsform/ServiceTypeRevenueReportForm";
import ServiceTypeRevenueReportView from "../features/reports/reportsform/ServiceTypeRevenueReportView";
import FollowupEfficiencyReportForm from "../features/reports/reportsform/FollowupEfficiencyReportForm";
import FollowupEfficiencyReportView from "../features/reports/reportsform/FollowupEfficiencyReportView";
import DailyPerformanceSnapshotReportView from "../features/reports/reportsform/DailyPerformanceSnapshotReportView";
import DailyPerformanceSnapshotReportForm from "../features/reports/reportsform/DailyPerformanceSnapshotReportForm";
import Career from "../features/career/Career";
import Booking from "../features/booking/Booking";
import CreateSpecialityType from "../features/specialitytype/CreateSpecialityType";

const MainRouter = () => {
  const navigate = useNavigate();
  return (
    <Routes>
      <RouteItem
        path="login"
        element={
          <PrivateLoginRoute>
            <Login />
          </PrivateLoginRoute>
        }
      />
      <RouteItem
        path="paymentreceiptcustomerview/:PaymentReceipt_GUID"
        element={<PaymentReceiptCustomerReport />}
      />
      <RouteItem
        path="tourbookinginvoice/:TourBookingNo"
        element={<TourBookingInvoiceView />}
      />
      <RouteItem
        path="companywisebookingreportview/:CompanyID/:DateType/:Type/:TourID/:FromDate/:ToDate"
        element={<CompanyWiseBookingReportView />}
      />
      <RouteItem
        path="userwisebookingreportview/:UserID/:TourID/:FromDate/:ToDate"
        element={<UserWiseBookingReportView />}
      />
      <RouteItem
        path="hotelblockroomstatusview/:TourID/:TourDate"
        element={<HotelBlockRoomStatusReportView />}
      />
      <RouteItem
        path="customerreportview/:DateType/:TourID/:TourDate/:FromDate/:ToDate"
        element={<CustomerReportView />}
      />
      <RouteItem
        path="tourreportview/:TourID/:TourDate/:FromDate/:ToDate"
        element={<TourReportView />}
      />
      <RouteItem
        path="leadreportview/:filterFromDate/:filterToDate/:filterAssignedTo/:filterLeadSourceID/:filterLeadStageID/:filterUnassignedLeads"
        element={<LeadReportView />}
      />
      <RouteItem
        path="inquiryreportview/:filterFromDate/:filterToDate/:filterRequirementType/:filterDestination/:filterInquiryStageID/:filterInquiryStatus/:filterInquirySourceID/:filterAssignedTo"
        element={<InquiryReportView />}
      />
      <RouteItem
        path="quotationreportview/:filterFromDate/:filterToDate/:filterSector/:filterType/:filterCreatedBy"
        element={<QuotationReportView />}
      />
      <RouteItem
        path="fitbookingreportview/:filterFromDate/:filterToDate/:filterSector/:filterCreatedBy"
        element={<FITBookingReportView />}
      />
      <RouteItem
        path="bookingsummaryreportview/:filterFromDate/:filterToDate/:filterSector/:filterCreatedBy/:CustomerName/:ConfirmStatus/:filterRequirementType"
        element={<BookingSummaryReportView />}
      />
      <RouteItem
        path="revenuegeneratedbyUserreportview/:filterFromDate/:filterToDate/:filterSector/:BranchIDs/:DateType"
        element={<RevenueGeneratedByUserReportView />}
      />
      <RouteItem
        path="inquiryconversionreportview/:filterFromDate/:filterToDate/:filterSector/:InquiryType/:LeadSourceID/:AssignedUserId"
        element={<InquiryConversionReportView />}
      />
      <RouteItem
        path="destinationwiseperformancereportview/:filterFromDate/:filterToDate/:RegionID/:CountryID/:filterCreatedBy/:RequirementType"
        element={<DestinationWisePerformanceReportView />}
      />
      <RouteItem
        path="leadsourceanalysisreportview/:filterFromDate/:filterToDate/:filterSector/:LeadSource/:AssignedUserId"
        element={<LeadSourceAnalysisReportView />}
      />
      <RouteItem
        path="userperformancereportview/:filterFromDate/:filterToDate/:filterSector/:InquiryType/:BranchIDs/:DateType"
        element={<UserPerformanceReportView />}
      />
      <RouteItem
        path="quotationstatusreportview/:filterFromDate/:filterToDate/:Destination/:Status/:InquiryType/:User"
        element={<QuotationStatusReportView />}
      />
      <RouteItem
        path="profitabilityreportview/:filterFromDate/:filterToDate/:filterDestination/:filterRequirementType/:filterUser"
        element={<ProfitabilityReportView />}
      />
      <RouteItem
        path="pendingInquiryfollowupreportview/:filterFromDate/:filterToDate/:filterDestination/:filterStatus/:filterUser"
        element={<PendingInquiryFollowupReportView />}
      />
      <RouteItem
        path="lostinquiryanalysisreportview/:filterFromDate/:filterToDate/:filterDestination/:AssignedUser"
        element={<LostInquiryAnalysisReportView />}
      />
      <RouteItem
        path="monthlyrevenuetrendreportview/:filterYear/:Destination/:filterUserID/:BranchID"
        element={<MonthlyRevenueTrendReportView />}
      />
      <RouteItem
        path="upcomingdeparturedatareportview/:filterFromDate/:filterToDate/:Destination/:Status"
        element={<UpcomingDepartureDataReportView />}
      />
      <RouteItem
        path="customerretentionreportview/:filterFromDate/:filterToDate/:CustomerName/:QueryType"
        element={<CustomerRetentionReportView />}
      />
      <RouteItem
        path="gstandtaxsummaryreportview/:filterFromDate/:filterToDate/:filterGSTRate/:filterUser/:BranchID"
        element={<GSTAndTaxSummaryReportView />}
      />
      <RouteItem
        path="servicetyperevenuereportview/:filterFromDate/:filterToDate/:Destination/:filterUser/:Status"
        element={<ServiceTypeRevenueReportView />}
      />
      <RouteItem
        path="followupefficiencyreportview/:filterFromDate/:filterToDate/:filterUser"
        element={<FollowupEfficiencyReportView />}
      />
      <RouteItem
        path="dailyperformancesnapshotreportview/:filterFromDate/:filterToDate/:Destination/:filterUser"
        element={<DailyPerformanceSnapshotReportView />}
      />
      <RouteItem
        path="tourbookingdetails/:TourBookingNo"
        element={<TourBookingReport />}
      />
      <RouteItem
        path="ledgerreportview/:BookingNo"
        element={<ManageLedgerView />}
      />
      <RouteItem
        path="grouproute/:GroupRouteID"
        element={<GroupRoutePrint />}
      />
      <RouteItem
        path="quotation/package/view/:Quot_GUID"
        element={<PackageQuotationPrint />}
      />
      <RouteItem
        path="fitbooking/view/:PackageBooking_GUID"
        element={<FITBookingPrint />}
      />
      <RouteItem
        path="hotelvoucherview/:AccomodationID/:PackageBooking_GUID"
        element={<HotelVoucherView />}
      />
      <RouteItem
        path="quotation/hotel/view/:HotelQuot_GUID"
        element={<HotelQuotePrint />}
      />
      <RouteItem
        path="quotation/flight/view/:FlightQuot_GUID"
        element={<FlightQuotePrint />}
      />
      <RouteItem
        path="quotation/visa/view/:VisaQuot_GUID"
        element={<VisaQuotePrint />}
      />
      <RouteItem
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <RouteItem index={true} element={<Dashboard />} />
        <RouteItem path="dashboard/booking" element={<DashboardBookings />} />
        <RouteItem
          path="dashboard/fitbooking"
          element={<DashboardFITBookings />}
        />
        <RouteItem path="dashboard/lead" element={<DashboardLeads />} />
        <RouteItem path="dashboard/inquiry" element={<DashBoardInquiries />} />
        <RouteItem
          path="dashboard/inquiry/:Type"
          element={<DashBoardInquiries />}
        />
        <RouteItem
          path="dashboard/follow-ups"
          element={<DashboardFollowups />}
        />
        <RouteItem
          path="dashboard/followups/:Type"
          element={<DashboardFollowupsChartWise />}
        />
        <RouteItem
          path="dashboard/quotation"
          element={<DashboardQuotations />}
        />
        <RouteItem path="menu" element={<Menu />} />
        <RouteItem path="rights" element={<Rights />} />
        <RouteItem path="country" element={<Country />} />
        <RouteItem path="visacategory" element={<VisaCategory />} />
        <RouteItem path="state" element={<State />} />
        <RouteItem path="city" element={<City />} />
        <RouteItem path="region" element={<Region />} />
        <RouteItem path="document" element={<Document />} />
        <RouteItem path="visacountry" element={<VisaCountry />} />
        <RouteItem path="sector" element={<Sector />} />
        <RouteItem path="sector/create" element={<CreateSector />} />
        <RouteItem path="sector/edit" element={<CreateSector />} />
        <RouteItem path="sectorcity" element={<SectorCity />} />
        <RouteItem path="roomtype" element={<RoomType />} />
        <RouteItem path="mealtype" element={<MealType />} />
        <RouteItem path="vendor" element={<Vendor />} />
        <RouteItem path="vendor/create" element={<CreateVendor />} />
        <RouteItem path="vendor/edit" element={<CreateVendor />} />
        <RouteItem path="vendortype" element={<VendorType />} />
        <RouteItem path="vehicletype" element={<VehicleType />} />
        <RouteItem path="sightseen" element={<Sightseen />} />
        <RouteItem path="travelpurpose" element={<TravelPurpose />} />
        <RouteItem
          path="visaprocessingoption"
          element={<VisaProcessingOption />}
        />
        <RouteItem path="additionalservice" element={<AdditionalService />} />
        <RouteItem path="employmentstatus" element={<EmploymentStatus />} />
        <RouteItem path="sponsorshiptype" element={<SponsorshipType />} />
        <RouteItem path="festivals" element={<Festivals />} />
        <RouteItem path="cancellationpolicy" element={<CancellationPolicy />} />
        <RouteItem path="leadsource" element={<LeadSource />} />
        <RouteItem path="vehicle" element={<Vehicle />} />
        <RouteItem path="vehicle/create" element={<CreateVehicle />} />
        <RouteItem path="vehicle/edit" element={<CreateVehicle />} />
        <RouteItem path="itinerary" element={<Itinerary />} />
        <RouteItem path="itineary/edit" element={<CreateItineary />} />
        <RouteItem path="itineary/create" element={<CreateItineary />} />
        <RouteItem path="itineraryfacility" element={<ItineraryFacility />} />
        <RouteItem path="agent/create" element={<CreateAgent />} />
        <RouteItem path="agent/edit" element={<CreateAgent />} />
        <RouteItem path="agent" element={<Agent />} />
        <RouteItem path="specialitytype" element={<SpecialityType />} />
        <RouteItem
          path="specialitytype/create"
          element={<CreateSpecialityType />}
        />
        <RouteItem
          path="specialitytype/edit"
          element={<CreateSpecialityType />}
        />
        <RouteItem path="nationality" element={<Nationality />} />
        <RouteItem path="gst" element={<Gst />} />
        <RouteItem path="termsandcondition" element={<TermsAndCondition />} />
        <RouteItem path="user" element={<User />} />
        <RouteItem path="user/create" element={<CreateUser />} />
        <RouteItem path="user/edit" element={<CreateUser />} />
        <RouteItem path="hotelblock" element={<HotelBlock />} />
        <RouteItem path="hotelblock/create" element={<CreateHotelBlock />} />
        <RouteItem path="hotelblock/edit" element={<CreateHotelBlock />} />
        <RouteItem path="tour" element={<Tour />} />
        <RouteItem path="tour/create" element={<CreateTour />} />
        <RouteItem path="tour/edit" element={<CreateTour />} />
        <RouteItem path="company" element={<Company />} />
        <RouteItem path="company/create" element={<CreateCompany />} />
        <RouteItem path="company/edit" element={<CreateCompany />} />
        <RouteItem path="airlineblock" element={<AirlineBlock />} />
        <RouteItem
          path="airlineblock/create"
          element={<CreateAirlineBlock />}
        />
        <RouteItem path="airlineblock/edit" element={<CreateAirlineBlock />} />
        <RouteItem path="hotel" element={<Hotel />} />
        <RouteItem path="hotel/create" element={<CreateHotel />} />
        <RouteItem path="hotel/edit" element={<CreateHotel />} />
        <RouteItem path="currency" element={<Currency />} />
        <RouteItem path="airline" element={<Airline />} />
        <RouteItem path="airline/create" element={<CreateAirline />} />
        <RouteItem path="airline/edit" element={<CreateAirline />} />
        {/* <RouteItem path="airport" element={<Airport />} /> */}
        <RouteItem path="airlineclass" element={<AirlineClass />} />
        <RouteItem path="vehiclesharingpax" element={<VehicleSharingPax />} />
        <RouteItem path="flightplace" element={<FlightPlace />} />
        <RouteItem path="paxtype" element={<PaxType />} />
        <RouteItem path="route" element={<Route />} />
        <RouteItem path="branch" element={<Branch />} />
        <RouteItem path="branch/create" element={<CreateBranch />} />
        <RouteItem path="branch/edit" element={<CreateBranch />} />
        <RouteItem path="foodoption" element={<FoodOption />} />
        <RouteItem path="tourservice" element={<TourService />} />
        <RouteItem path="visagateway" element={<VisaGateway />} />
        <RouteItem path="grouproute" element={<GroupRoute />} />
        <RouteItem path="grouproute/create" element={<CreateGroupRoute />} />
        <RouteItem path="grouproute/edit" element={<CreateGroupRoute />} />
        <RouteItem path="tourbooking" element={<TourBooking />} />
        <RouteItem path="tourbooking/create" element={<CreateTourBooking />} />
        <RouteItem path="tourbooking/edit" element={<CreateTourBooking />} />
        <RouteItem path="hotelvoucher" element={<HotelVoucher />} />
        <RouteItem path="testimonial" element={<Testimonial />} />
        <RouteItem path="visaentrytype" element={<VisaEntryType />} />

        <RouteItem path="banner" element={<Banner />} />
        <RouteItem path="banner/create" element={<CreateBanner />} />
        <RouteItem path="banner/edit" element={<CreateBanner />} />

        <RouteItem path="seotag" element={<SeoTag />} />
        <RouteItem path="seotag/create" element={<CreateSeoTag />} />
        <RouteItem path="seotag/edit" element={<CreateSeoTag />} />

        <RouteItem path="blog" element={<Blog />} />
        <RouteItem path="blog/create" element={<CreateBlog />} />
        <RouteItem path="blog/edit" element={<CreateBlog />} />

        <RouteItem path="faq" element={<FAQ />} />
        <RouteItem path="faq/create" element={<CreateFAQ />} />
        <RouteItem path="faq/edit" element={<CreateFAQ />} />

        <RouteItem path="service" element={<Service />} />
        <RouteItem path="service/create" element={<CreateService />} />
        <RouteItem path="service/edit" element={<CreateService />} />

        <RouteItem path="cms" element={<CMS />} />
        <RouteItem path="cms/edit" element={<CreateCMS />} />
        <RouteItem path="cms/create" element={<CreateCMS />} />

        <RouteItem path="usefullinks" element={<UsefulLinks />} />
        <RouteItem path="usefullinks/create" element={<CreateUsefulLinks />} />
        <RouteItem path="usefullinks/edit" element={<CreateUsefulLinks />} />

        <RouteItem
          path="hotelvoucher/create"
          element={<CreateHotelVoucher />}
        />
        <RouteItem path="hotelvoucher/edit" element={<CreateHotelVoucher />} />
        <RouteItem path="paymentreceipt" element={<PaymentReceipt />} />
        <RouteItem
          path="paymentreceipt/create"
          element={<CreatePaymentReceipt />}
        />
        <RouteItem
          path="paymentreceipt/edit"
          element={<CreatePaymentReceipt />}
        />
        <RouteItem path="routevoucher" element={<RouteVoucher />} />
        <RouteItem
          path="routevoucher/create"
          element={<CreateRouteVoucher />}
        />
        <RouteItem path="routevoucher/edit" element={<CreateRouteVoucher />} />
        <RouteItem path="roomcategory" element={<RoomCategory />} />
        <RouteItem path="hotelmapping" element={<HotelMapping />} />
        <RouteItem path="airlinevoucher" element={<AirlineVoucher />} />
        <RouteItem
          path="airlinevoucher/create"
          element={<CreateAirlineVoucher />}
        />
        <RouteItem
          path="airlinevoucher/edit"
          element={<CreateAirlineVoucher />}
        />
        <RouteItem
          path="companywisebookingreportform"
          element={<CompanyWiseBookingReportForm />}
        />
        <RouteItem
          path="userwisetourbookingreportform"
          element={<UserWiseBookingReportForm />}
        />
        <RouteItem path="setting" element={<Setting />} />
        <RouteItem
          path="hotelblockroomstatusform"
          element={<HotelBlockRoomStatusReportForm />}
        />
        <RouteItem path="customerreportform" element={<CustomerReportForm />} />
        <RouteItem path="tourreportform" element={<TourReportForm />} />
        <RouteItem path="leadreportform" element={<LeadReportForm />} />
        <RouteItem path="inquiryreportform" element={<InquiryReportForm />} />
        <RouteItem
          path="quotationreportform"
          element={<QuotationReportForm />}
        />
        <RouteItem
          path="fitbookingreportform"
          element={<FITBookingReportForm />}
        />
        <RouteItem
          path="tourbookinginvoiceform"
          element={<TourBookingInvoiceForm />}
        />
        <RouteItem
          path="bookingsummaryreportform"
          element={<BookingSummaryReportForm />}
        />
        <RouteItem
          path="revenuegeneratedbyUserreportform"
          element={<RevenueGeneratedByUserReportForm />}
        />
        <RouteItem
          path="inquiryconversionreportform"
          element={<InquiryConversionReportForm />}
        />
        <RouteItem
          path="destinationwiseperformancereportform"
          element={<DestinationWisePerformanceReportForm />}
        />
        <RouteItem
          path="leadsourceanalysisreportform"
          element={<LeadSourceAnalysisReportForm />}
        />
        <RouteItem
          path="userperformancereportform"
          element={<UserPerformanceReportForm />}
        />
        <RouteItem
          path="quotationstatusreportform"
          element={<QuotationStatusReportForm />}
        />
        <RouteItem
          path="profitabilityreportform"
          element={<ProfitabilityReportForm />}
        />
        <RouteItem
          path="pendingInquiryfollowupreportform"
          element={<PendingInquiryFollowupReportForm />}
        />
        <RouteItem
          path="lostinquiryanalysisreportform"
          element={<LostInquiryAnalysisReportForm />}
        />
        <RouteItem
          path="monthlyrevenuetrendreportform"
          element={<MonthlyRevenueTrendReportForm />}
        />
        <RouteItem
          path="upcomingdeparturedatareportform"
          element={<UpcomingDepartureDataReportForm />}
        />
        <RouteItem
          path="customerretentionreportform"
          element={<CustomerRetentionReportForm />}
        />
        <RouteItem
          path="gstandtaxsummaryreportform"
          element={<GSTAndTaxSummaryReportForm />}
        />
        <RouteItem
          path="servicetyperevenuereportform"
          element={<ServiceTypeRevenueReportForm />}
        />
        <RouteItem
          path="followupefficiencyreportform"
          element={<FollowupEfficiencyReportForm />}
        />
        <RouteItem
          path="dailyperformancesnapshotreportform"
          element={<DailyPerformanceSnapshotReportForm />}
        />
        <RouteItem path="airlineblockview" element={<AirlineBlockView />} />
        <RouteItem path="ledgerreportform" element={<ManageLedgerForm />} />
        <RouteItem path="usertype" element={<UserType />} />
        <RouteItem path="usertype/create" element={<CreateUserType />} />
        <RouteItem path="usertype/edit" element={<CreateUserType />} />
        <RouteItem path="inquiry" element={<Inquiry />} />
        <RouteItem path="inquiry/create" element={<CreateInquiry />} />
        <RouteItem path="inquiry/edit" element={<CreateInquiry />} />
        <RouteItem path="leadstage" element={<LeadStage />} />
        <RouteItem path="quotation" element={<Quotation />} />
        <RouteItem
          path="quotation/package/create"
          element={<CreateQuotation />}
        />
        <RouteItem
          path="quotation/package/edit"
          element={<CreateQuotation />}
        />
        <RouteItem
          path="quotation/flight/create"
          element={<CreateFlightQuotation />}
        />
        <RouteItem
          path="quotation/flight/edit"
          element={<CreateFlightQuotation />}
        />
        <RouteItem
          path="quotation/hotel/create"
          element={<CreateHotelQuotation />}
        />
        <RouteItem
          path="quotation/hotel/edit"
          element={<CreateHotelQuotation />}
        />
        <RouteItem
          path="quotation/visa/create"
          element={<CreateVisaQuotation />}
        />
        <RouteItem
          path="quotation/visa/edit"
          element={<CreateVisaQuotation />}
        />
        <RouteItem path="integrations" element={<Integrations />} />
        <RouteItem
          path="integrations/facebook"
          element={<FacebookIntegration />}
        />
        <RouteItem path="integrations/leadcenter" element={<LeadCenter />} />
        <RouteItem
          path="integrations/studentleads"
          element={<LeadCenterList />}
        />
        <RouteItem path="lead" element={<Lead />} />
        <RouteItem path="contact" element={<Contact />} />
        <RouteItem path="contact/edit" element={<EditContact />} />
        <RouteItem path="fitbooking" element={<FITBooking />} />
        <RouteItem path="fitbooking/create" element={<CreateFITBooking />} />
        <RouteItem path="fitbooking/edit" element={<CreateFITBooking />} />
        <RouteItem
          path="fitbookingcancellation"
          element={<FITBookingCancellation />}
        />
        <RouteItem path="brochure" element={<Brochure />} />
        <RouteItem path="brochure/create" element={<CreateBrochure />} />
        <RouteItem path="brochure/edit" element={<CreateBrochure />} />
        <RouteItem path="adminsetting" element={<AdminSetting />} />
        <RouteItem path="organization" element={<CreateOrganization />} />
        <RouteItem path="template" element={<Template />} />
        <RouteItem path="template/edit" element={<CreateTemplate />} />
        <RouteItem path="template/create" element={<CreateTemplate />} />
        <RouteItem
          path="autotrigger/whatsapp"
          element={<WhatsappAutoTrigger />}
        />
        <RouteItem
          path="autotrigger/whatsapp/edit"
          element={<CreateWhatsappAutoTrigger />}
        />
        <RouteItem
          path="autotrigger/whatsapp/create"
          element={<CreateWhatsappAutoTrigger />}
        />
        <RouteItem path="autotrigger/email" element={<EmailAutoTrigger />} />
        <RouteItem
          path="autotrigger/email/edit"
          element={<CreateEmailAutoTrigger />}
        />
        <RouteItem
          path="autotrigger/email/create"
          element={<CreateEmailAutoTrigger />}
        />
        <RouteItem path="leadassignsetting" element={<LeadAssignSetting />} />
        <RouteItem path="client" element={<ClientLogo />} />
        <RouteItem path="webbranch" element={<WebBranch />} />
        <RouteItem path="webbranch/create" element={<CreateWebBranch />} />
        <RouteItem path="webbranch/edit" element={<CreateWebBranch />} />
        <RouteItem path="community" element={<Community />} />
        <RouteItem path="community/create" element={<CreateCommunity />} />
        <RouteItem path="community/edit" element={<CreateCommunity />} />
        <RouteItem path="instagramstory" element={<InstagramStory />} />
        <RouteItem path="activity" element={<Activity />} />
        <RouteItem path="weekendgateways" element={<Weekendgateways />} />
        <RouteItem path="newsletter" element={<Newsletter />} />
        <RouteItem path="couponcode" element={<CouponCode />} />
        <RouteItem path="section" element={<Section />} />
        <RouteItem path="designation" element={<Designation />} />
        <RouteItem path="career" element={<Career />} />
        <RouteItem path="booking" element={<Booking />} />
        <RouteItem
          path="weekendgateways/create"
          element={<CreateWeekendgateways />}
        />
        <RouteItem
          path="weekendgateways/edit"
          element={<CreateWeekendgateways />}
        />
      </RouteItem>
      <RouteItem
        path="*"
        element={
          <RippleButton
            onClick={() => navigate("/")}
            style={{ margin: "20px" }}
          >
            Back to Home
          </RippleButton>
        }
      />
    </Routes>
  );
};

export default MainRouter;
